export const encode = (input: any) => {
  return btoa(JSON.stringify(input))
}

export const getDashboardStyle = () => ({
  position: 'fixed',
  top: '0',
  left: '0',
  width: '100%',
  height: '100%',
  border: 'none',
  zIndex: '2147483647',
  backgroundColor: '#fff',
} as const)
